import { HttpStatusCode } from "axios";
import CollegeService from "../../apiServices/masters/collegeService";

import { alertConstants } from "../../helper/sweet-alert";
import {
  setCollege,
  setColleges,
} from "../../store/slices/master/collegeSlice";

export function getCollege(id?: number) {
  return async function (dispatch: any, getState: any) {
    let response = await CollegeService.getCollege(id);
    if (response?.success === true) {
      dispatch(setCollege(response.data));
    } else {
      console.log("error");
    }
  };
}

export function getColleges() {
  return async function (dispatch: any, getState: any) {
    let response = await CollegeService.getColleges();
    if (response?.success === true) {
      dispatch(setColleges(response.data));
    } else {
      console.log("error");
    }
  };
}

export function createCollege(data: any, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await CollegeService.createCollege(data);
    const name = data.get("collegeName");
    if (response?.success === true) {
      callback(alertConstants.success);
    } else {
      if (response.status === HttpStatusCode.Conflict) {
        callback(alertConstants.conflict, name);
      } else {
        callback(alertConstants.error);
      }
    }
  };
}

export function updateCollege(data: any, id: number, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await CollegeService.updateCollege(data, id);
    if (response?.success === true) {
      callback(alertConstants.success);
    } else {
      if (response.status === HttpStatusCode.Conflict) {
        callback(alertConstants.conflict);
      } else {
        callback(alertConstants.error);
      }
    }
  };
}

export function deleteCollege(id: number, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await CollegeService.deleteCollege(id);
    if (response === true) {
      callback(alertConstants.inactiveSuccess);
    } else {
      callback(alertConstants.inactiveFailure);
    }
  };
}
